// GENERATED by scripts/build-icons.mjs from icons/corner-up-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const CornerUpLeft = createIcon('corner-up-left', [
  ['path', { d: "M20 20v-7a4 4 0 0 0-4-4H4" }],
  ['path', { d: "M9 14 4 9l5-5" }],
])
